import '../text-with-background-image';
import '../contact-info';
import './css/index.css';